import { render, staticRenderFns } from "./ViewModifiers.vue?vue&type=template&id=5391b747&"
import script from "./ViewModifiers.vue?vue&type=script&lang=js&"
export * from "./ViewModifiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fodchef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports